const translation = {
  SERVICES_TITLE_H5: 'What I Offer',
  SERVICES_TITLE_H2: 'Services',
  SERVICES_1: 'Frontend Dev',
  SERVICES_2: 'Backend Dev',
  SERVICES_3: 'Freelance',

  SERVICES_1_SUB_1: 'Create Frontend App using any framework you wish',
  SERVICES_1_SUB_2: 'Improving Site Speed and Conversions',
  SERVICES_1_SUB_3: 'Remove Developer Dependencies',
  SERVICES_1_SUB_4: 'Html, Css, Scss, React, Angular, Vue, Javascript',
  SERVICES_1_SUB_5: 'Implement any state management Redux, Redux saga, NGrx',
  SERVICES_1_SUB_6: 'Code optimization',
  SERVICES_1_SUB_7: 'Implement microservices architecture',
  SERVICES_1_SUB_8: 'Fixing Bugs',

  SERVICES_2_SUB_1: 'Create Backend App using Nodejs, Nestjs and Python',
  SERVICES_2_SUB_2: 'MongoDB, MysQL',
  SERVICES_2_SUB_3: 'Improving Backend structure',
  SERVICES_2_SUB_4: 'Remove Developer Dependencies',
  SERVICES_2_SUB_5: 'Writing Scripts for deployment',
  SERVICES_2_SUB_6: 'Hosting',
  SERVICES_2_SUB_7: 'Code optimization',
  SERVICES_2_SUB_8: 'Implement microservices architecture',
  SERVICES_2_SUB_9: 'Fixing Bugs',

  SERVICES_3_SUB_1: 'Create Fullstack web App',
  SERVICES_3_SUB_2: 'Hosting',
  SERVICES_3_SUB_3: 'App Maintenance',
  SERVICES_3_SUB_4: 'Full time Support',
  SERVICES_3_SUB_5: 'Code optimization',
};

export default translation;
